import * as React from 'react';
import { connect } from 'react-redux';
import { CategoriesService } from '../../services/categoriesService';
import IBookmarkState from './interfaces/bookmarkState';
import ICreateModal from './interfaces/createModal';
import { actionCreators } from './redux/actions';
import { createPortal } from 'react-dom';

class CreateBookmarkModal extends React.Component<ICreateModal, null> {
    render() {
        const buttonIsDisabled = !this.props.newCategoryName;

        return (
            createPortal(
                <React.Fragment>
                    {this.props.display
                        ?
                        (
                            <div className="bookmarks__modal" onClick={(event) => event.stopPropagation()}>
                                <div className="bookmarks__modal-backdrop"></div>
                                <div className="bookmarks__modal-innercontainer">
                                    <button onClick={(event) => this.props.toggleCreateModal(event, this.props.displayCategorizeModalAfterCreateModal)} className="modal__close">Stäng</button>
                                    <div className="modal__content">
                                        <h2 className="modal__title">Lägg till favoritkategori</h2>
                                        <div className="share-content">
                                            <div className="form-field  share-content__form-field">
                                                <input type="text" id="categoryName" className="share-content__email" placeholder="Ange namn på kategorin" autoComplete="off" autoFocus value={this.props.newCategoryName} onChange={(event) => this.props.setNewCategoryName(event)} />
                                                <label className="share-content__label" htmlFor="categoryName">Namn på kategorin</label>
                                            </div>
                                        </div>
                                        <div className="button-group modal__button-group">
                                            <button className="genericBtn alternate" onClick={(event) => this.props.toggleCreateModal(event, this.props.displayCategorizeModalAfterCreateModal)}>Avbryt</button>
                                            <button className={`genericBtn primary ${buttonIsDisabled ? 'modal__button--disabled' : ''}`} onClick={(event) => this.props.createNewCategory(event, this.props.newCategoryName, this.props.categories, this.props.displayCategorizeModalAfterCreateModal)}>Skapa</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                        : null
                    }
                </React.Fragment>,
                document.body)
        );
    }
}

const mapDispatchToProps = (dispatch, ownProps): ICreateModal => {
    const categoriesService = new CategoriesService();
    return {
        ...ownProps,
        toggleCreateModal: (event, displayCategorizeModalAfterCreateModal) => {
            event.preventDefault();
            dispatch(actionCreators.toggleCreateModal());
            dispatch(actionCreators.setNewCategoryName(''));
            if (displayCategorizeModalAfterCreateModal) {
                dispatch(actionCreators.toggleCategorizeModal());
                dispatch(actionCreators.setDisplayCategorizeModalAfterCreateModal(false));
            }
        },
        createNewCategory: (event, newCategoryName, categories, displayCategorizeModalAfterCreateModal) => {
            event.preventDefault();
            if (newCategoryName) {
                categoriesService.createCategory({ name: newCategoryName }, (response) => {
                    if (response) {
                        if (categories) {
                            const c = [...categories];
                            if (response && response.id && response.name) {
                                const edited = {
                                    categoryId: response.id,
                                    categoryName: response.name
                                };
                                c.push(edited);
                            }
                            const sorted = c.sort((a, b) => {
                                if (a.categoryName && b.categoryName) {
                                    if (a.categoryName > b.categoryName) {
                                        return 1;
                                    }
                                    return -1;
                                }
                            })
                            dispatch(actionCreators.populateCategories(sorted));
                        }

                        dispatch(actionCreators.toggleCreateModal());
                        dispatch(actionCreators.setToastBarType('success'));
                        dispatch(actionCreators.setToastBarMessage('Kategori skapad'));
                        dispatch(actionCreators.toggleToastBar());

                        if (displayCategorizeModalAfterCreateModal) {
                            if (response) {
                                dispatch(actionCreators.setSelectedCategoryId(response.id));
                            }
                            dispatch(actionCreators.toggleCategorizeModal());
                            dispatch(actionCreators.setDisplayCategorizeModalAfterCreateModal(false));
                        }

                        if (newCategoryName) {
                            dispatch(actionCreators.setNewCategoryName(''))
                        }

                    }

                }, (error) => {
                    dispatch(actionCreators.setToastBarType('warn'));
                    dispatch(actionCreators.setToastBarMessage('Kunde inte skapa ny kategori'));
                    dispatch(actionCreators.toggleToastBar());
                    console.error(error);
                });
            }
        },
        setNewCategoryName: (event) => {
            event.preventDefault();
            dispatch(actionCreators.setNewCategoryName(event.target.value))
        }
    };
}

const mapStateToProps = (state: IBookmarkState): ICreateModal => {
    return { display: state.displayCreateModal, newCategoryName: state.newCategoryName, categories: state.categories, displayCategorizeModalAfterCreateModal: state.displayCategorizeModalAfterCreateModal };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateBookmarkModal);